import axios from 'axios';

import { BERRY_API_URL } from 'src/constants';
import {
  IBerryChatResponse,
  IBerryMessagePayload,
  IBerrySession,
  IBerrySessionDetail,
} from 'src/models/berry.model';

const berryAxios = axios.create({
  baseURL: BERRY_API_URL,
});

class BerryApiService {
  startSession = (): Promise<IBerrySession> =>
    berryAxios.post('/api/berry/session/start', {}).then((res) => res.data);

  sendMessage = (payload: IBerryMessagePayload): Promise<IBerryChatResponse> =>
    berryAxios.post('/api/berry/chat', payload).then((res) => res.data);

  getSession = (sessionId: string): Promise<IBerrySessionDetail> =>
    berryAxios.get(`/api/berry/session/${sessionId}`).then((res) => res.data);
}

export const berryApiService = new BerryApiService();
